import { render, staticRenderFns } from "./InvoiceFixedPrice.vue?vue&type=template&id=d4560ffe&"
import script from "./InvoiceFixedPrice.vue?vue&type=script&lang=js&"
export * from "./InvoiceFixedPrice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports